<template>
  <button
    class="relative btn"
    :type="type"
    v-bind="$attrs"
    :disabled="loading"
    :class="[`btn-${variant}`, size ? `btn-${size}` : '']"
  >
    <svg
      v-if="loading"
      class="
        animate-spin
        absolute
        left-0
        right-0
        top-0
        bottom-0
        h-8
        w-8
        text-green
        m-auto
      "
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        class="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        stroke-width="4"
      ></circle>
      <path
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
    <span :class="{ 'opacity-0': loading }"><slot /></span>
  </button>
</template>

<script>
export default {
  name: 'Button',
  props: {
    type: {
      type: String,
      default: 'button'
    },
    loading: {
      type: Boolean,
      default: false
    },
    variant: {
      default: 'primary'
    },
    size: {
      default: ''
    },
    href: {
      type: String,
      default: ''
    }
  }
};
</script>
